var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlockGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 129,
    height: 259,
    viewBox: "0 0 129 259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M8.644 79.794H119.69v121.021H8.644z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.29)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    stroke: "#A5A5A5",
    strokeWidth: 1.072,
    d: "M114.308 258.183c7.23 0 13.085-5.679 13.085-12.677V13.217c0-7-5.856-12.68-13.085-12.68H13.618C6.39.536.536 6.216.536 13.216v232.289c0 6.999 5.853 12.677 13.082 12.677h100.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    stroke: "#A5A5A5",
    strokeWidth: 1.072,
    d: "M58.634 13.16c0 1.45 1.075 2.632 2.405 2.632h16.509c1.333 0 2.408-1.181 2.408-2.632 0-1.454-1.075-2.632-2.408-2.632h-16.51c-1.33 0-2.404 1.178-2.404 2.632z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.639,
    cy: 13.166,
    fill: "#F7F7F7",
    stroke: "#A5A5A5",
    strokeWidth: 1.072,
    rx: 2.665,
    ry: 2.637
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    fillRule: "nonzero",
    d: "M7.443 29.517a3.455 3.455 0 0 1 3.455-3.455h106.1a3.455 3.455 0 0 1 3.455 3.455v205.595a3.455 3.455 0 0 1-3.455 3.455h-106.1a3.455 3.455 0 0 1-3.455-3.455V29.517z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    fillRule: "nonzero",
    d: "M8.515 29.517v205.595a2.383 2.383 0 0 0 2.383 2.383h106.1a2.383 2.383 0 0 0 2.383-2.383V29.517a2.383 2.383 0 0 0-2.383-2.383h-106.1a2.383 2.383 0 0 0-2.383 2.383z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M8.644 39.423v16.479c0 .105 1.066.19 2.38.19h105.955c1.314 0 2.38-.085 2.38-.19v-16.48c0-.105-1.066-.19-2.38-.19H11.024c-1.314 0-2.38.085-2.38.19z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.989 212.784h84.513v1.675H20.989zM21.278 216.454h84.514v1.675H21.278zM21.278 220.443h84.514v1.676H21.278zM43.886 203.474h38.38v5h-38.38z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.644 55.856h110.714v24.648H8.644z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M8.644 79.794h110.715v1H8.644zM8.644 55.856h110.715v1H8.644z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#727272",
    fontFamily: "HelveticaNeue-Medium, Helvetica Neue",
    fontSize: 3.99,
    fontWeight: 400,
    transform: "translate(32.582 60.51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4
  }, "no-reply@zinier.com")), /*#__PURE__*/React.createElement("text", {
    fill: "#A5A5A5",
    fontFamily: "HelveticaNeue, Helvetica Neue",
    fontSize: 3.325,
    transform: "translate(32.582 60.51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.655
  }, "to me")), /*#__PURE__*/React.createElement("text", {
    fill: "#A5A5A5",
    fontFamily: "HelveticaNeue, Helvetica Neue",
    fontSize: 3.325,
    transform: "translate(32.582 60.51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12.309
  }, "2:19 pm")), /*#__PURE__*/React.createElement("text", {
    fill: "#FF6B35",
    fontFamily: "HelveticaNeue, Helvetica Neue",
    fontSize: 3.325,
    transform: "translate(32.582 60.51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13.299,
    y: 12.309
  }, "View details")), /*#__PURE__*/React.createElement("g", {
    fill: "#A5A5A5",
    fillRule: "nonzero",
    transform: "translate(108.387 59.845)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.325,
    cy: 3.99,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.32,
    cy: 3.99,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.33,
    cy: 3.99,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FF6B35"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M20.946 74.142a6.65 6.65 0 1 1 0-13.3 6.65 6.65 0 0 1 0 13.3zm0-.665a5.985 5.985 0 1 0 0-11.97 5.985 5.985 0 0 0 0 11.97z"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "HelveticaNeue, Helvetica Neue",
    fontSize: 6.649,
    transform: "translate(13.964 60.51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.655,
    y: 8.66
  }, "N"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "#727272",
    fontFamily: "HelveticaNeue-Medium, Helvetica Neue",
    fontSize: 4.987,
    fontWeight: 400,
    transform: "translate(14.629 42.557)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5
  }, "John Doe has invited you to join Zinier")), /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    fillRule: "nonzero",
    d: "M113.041 48.278l1.255.66-.24-1.397 1.015-.99-1.403-.203-.627-1.27-.627 1.27-1.402.204 1.014.989-.24 1.397 1.255-.66zm-1.872 1.51l.357-2.084-1.515-1.477 2.094-.304.936-1.897.936 1.897 2.094.304-1.515 1.477.358 2.085-1.873-.985-1.872.985z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    d: "M10.914 26.32h106.1a2.919 2.919 0 0 1 2.92 2.92v10.21H7.995V29.24a2.919 2.919 0 0 1 2.918-2.92z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M94.935 34.349a.104.104 0 1 1-.208 0v-2.702a.104.104 0 1 1 .208 0v2.702zm-.415-3.637h-1.455v-.311c0-.172.14-.312.312-.312h.831c.172 0 .312.14.312.312v.311zm-.624 3.637a.104.104 0 1 1-.208 0v-2.702a.104.104 0 1 1 .208 0v2.702zm-1.039 0a.104.104 0 1 1-.208 0v-2.702a.104.104 0 1 1 .208 0v2.702zm3.221-3.637h-1.35v-.311a.52.52 0 0 0-.52-.52h-.831a.52.52 0 0 0-.52.52v.311h-1.35a.104.104 0 1 0 0 .208h.311v3.844c0 .287.233.52.52.52h2.909a.52.52 0 0 0 .52-.52V30.92h.311a.104.104 0 1 0 0-.208z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F7F7F7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.931 32.852c.072.085.19.085.261 0l2.285-2.031a.24.24 0 0 0-.101-.024h-4.618a.24.24 0 0 0-.109.027l2.282 2.028z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.323 33.006a.342.342 0 0 1-.261.128.342.342 0 0 1-.262-.128l-2.286-2.033a.37.37 0 0 0-.033.151v3.707c0 .18.124.327.277.327h4.618c.153 0 .277-.147.277-.327v-3.707a.369.369 0 0 0-.037-.16l-2.293 2.042z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F7F7F7",
    fillRule: "nonzero",
    transform: "translate(109.052 29.258)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.325,
    cy: 3.99,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.32,
    cy: 3.99,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.33,
    cy: 3.99,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.823 30.367l.002.002a.383.383 0 0 1 0 .552l-2.006 1.932h4.602a.394.394 0 1 1 0 .789H14.82l2.006 1.931a.383.383 0 0 1 0 .552l-.002.003a.41.41 0 0 1-.568 0l-2.686-2.585a.41.41 0 0 1 0-.59l2.686-2.586a.41.41 0 0 1 .568 0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.289 77.134)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A5A5A5",
    fillRule: "nonzero",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.09 86.849c0 .837-.676 1.515-1.508 1.515H7.537A1.512 1.512 0 0 1 6.03 86.85v-18.19c0-.838.675-1.516 1.507-1.516h9.045c.832 0 1.507.678 1.507 1.515v18.19zm-.755-18.19a.756.756 0 0 0-.753-.758H7.537a.756.756 0 0 0-.754.757v18.19c0 .42.338.758.754.758h9.045c.416 0 .753-.339.753-.757v-18.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.712 84.575c.208 0 .377.178.377.399 0 .22-.169.399-.377.399H6.407a.388.388 0 0 1-.377-.4c0-.22.168-.398.377-.398h11.305zM17.712 70.174c.208 0 .377.179.377.4 0 .22-.169.398-.377.398H6.407a.388.388 0 0 1-.377-.399c0-.22.168-.399.377-.399h11.305zM13.19 68.658c.208 0 .377.194.377.433 0 .238-.169.432-.377.432h-2.261c-.208 0-.377-.194-.377-.432 0-.239.169-.433.377-.433h2.261zM11.683 86.955c-.209 0-.377-.193-.377-.432s.168-.432.377-.432h.753c.208 0 .377.193.377.432s-.169.432-.377.432h-.753zM12.057 78.77c0 .062.05.111.108.111a.11.11 0 0 0 .108-.11.11.11 0 0 0-.108-.11.11.11 0 0 0-.108.11zm.9 0c0 .44-.355.795-.792.795a.793.793 0 0 1 0-1.589c.437 0 .792.355.792.795z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.676 80.074c0 .209-.228.379-.508.379s-.508-.17-.508-.38v-1.145c0-.21.227-.379.508-.379.28 0 .508.17.508.38v1.145zM10.409 76.637c0 .21-.169.379-.377.379a.378.378 0 0 1-.377-.379v-.859a2.383 2.383 0 0 1 4.74-.34.377.377 0 1 1-.746.108 1.627 1.627 0 0 0-3.24.232v.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.278 81.076a.808.808 0 0 1-.807.808H9.602a.808.808 0 0 1-.806-.808v-4.439c0-.21.169-.379.377-.379H14.9c.208 0 .377.17.377.38v4.438zm-5.728 0c0 .027.023.05.052.05h4.87c.029 0 .052-.023.052-.05v-4.06H9.55v4.06z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#A5A5A5",
    fillRule: "nonzero",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.09 54.035c0 .837-.676 1.516-1.508 1.516H7.537a1.512 1.512 0 0 1-1.507-1.516v-18.19c0-.837.675-1.516 1.507-1.516h9.045c.832 0 1.507.679 1.507 1.516v18.19zm-.755-18.19a.756.756 0 0 0-.753-.758H7.537a.756.756 0 0 0-.754.758v18.19c0 .419.338.758.754.758h9.045c.416 0 .753-.34.753-.758v-18.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.712 51.761c.208 0 .377.179.377.4 0 .22-.169.398-.377.398H6.407a.388.388 0 0 1-.377-.399c0-.22.168-.399.377-.399h11.305zM17.712 37.36c.208 0 .377.18.377.4 0 .22-.169.399-.377.399H6.407a.388.388 0 0 1-.377-.4c0-.22.168-.398.377-.398h11.305zM13.19 35.845c.208 0 .377.194.377.432 0 .239-.169.433-.377.433h-2.261c-.208 0-.377-.194-.377-.433 0-.238.169-.432.377-.432h2.261zM11.683 54.142c-.209 0-.377-.194-.377-.433 0-.238.168-.432.377-.432h.753c.208 0 .377.194.377.432 0 .24-.169.433-.377.433h-.753zM12.119 45.749l1.355-1.39a.375.375 0 0 1 .533-.005.38.38 0 0 1 .005.536l-1.624 1.665a.375.375 0 0 1-.538 0l-1.625-1.665a.38.38 0 0 1 .005-.536.375.375 0 0 1 .533.005l1.356 1.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.65 42.217c0-.186.194-.336.432-.336.239 0 .432.15.432.336v3.726c0 .185-.193.335-.432.335-.238 0-.432-.15-.432-.335v-3.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.224 46.473c0-.21.168-.38.377-.38.208 0 .376.17.376.38v1.332c0 .21-.168.38-.376.38H8.453a.378.378 0 0 1-.377-.38v-1.332c0-.21.17-.38.377-.38.208 0 .377.17.377.38v.953h6.394v-.953z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#A5A5A5",
    fillRule: "nonzero",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.09 21.222c0 .837-.676 1.516-1.508 1.516H7.537a1.512 1.512 0 0 1-1.507-1.516V3.032c0-.838.675-1.516 1.507-1.516h9.045c.832 0 1.507.678 1.507 1.516v18.19zm-.755-18.19a.756.756 0 0 0-.753-.758H7.537a.756.756 0 0 0-.754.758v18.19c0 .418.338.758.754.758h9.045c.416 0 .753-.34.753-.758V3.032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.712 18.948c.208 0 .377.179.377.399 0 .22-.169.399-.377.399H6.407a.388.388 0 0 1-.377-.4c0-.22.168-.398.377-.398h11.305zM17.712 4.548c.208 0 .377.178.377.398 0 .22-.169.4-.377.4H6.407a.388.388 0 0 1-.377-.4c0-.22.168-.398.377-.398h11.305zM13.19 3.032c.208 0 .377.228.377.509s-.169.51-.377.51h-2.261c-.208 0-.377-.229-.377-.51s.169-.51.377-.51h2.261zM11.683 21.328c-.209 0-.377-.193-.377-.432s.168-.432.377-.432h.753c.208 0 .377.193.377.432s-.169.432-.377.432h-.753zM8.24 10.297a.38.38 0 0 1-.008-.536.375.375 0 0 1 .533-.007l3.26 3.186c.013.014.04.014.053 0l3.267-3.193a.375.375 0 0 1 .533.007.38.38 0 0 1-.007.536l-3.267 3.194c-.307.3-.799.3-1.105 0l-3.26-3.187z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.371 10.298H8.748v4.317h6.623v-4.317zm.104 5.075h-6.83a.648.648 0 0 1-.65-.646v-4.54c0-.36.292-.647.65-.647h6.83c.356 0 .65.287.65.646v4.541c0 .36-.294.646-.65.646z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M29.794 4.993h38.379v5H29.794zM29.794 14.267h59.245v5H29.794zM29.794 37.807h38.379v5H29.794zM29.923 47.211h59.245v5H29.923zM29.794 70.895h38.379v5H29.794zM29.794 80.168h59.245v5H29.794z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 83.452,
    height: 1.427,
    x: 5.802,
    y: 60.771,
    fill: "#E5E5E5",
    rx: 0.515
  }), /*#__PURE__*/React.createElement("rect", {
    width: 83.452,
    height: 1.427,
    x: 5.279,
    y: 28.14,
    fill: "#E5E5E5",
    rx: 0.515
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.613 173.552)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.88,
    height: 16.06,
    fill: "#A5A5A5",
    fillRule: "nonzero",
    opacity: 0.5,
    rx: 2.66
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.69 5.39v2.926c0 .335-.076.627-.227.879-.15.251-.368.444-.653.578a2.351 2.351 0 0 1-1.01.201c-.586 0-1.041-.149-1.365-.447-.324-.298-.487-.705-.487-1.223V5.391h.964v2.768c0 .348.07.604.212.767.141.163.375.244.701.244.316 0 .545-.082.687-.246.143-.164.214-.42.214-.771V5.39h.963zm5.797 4.522h-1.228l-1.983-3.42h-.028c.04.604.06 1.035.06 1.293v2.127h-.864V5.391h1.219l1.98 3.386h.02a27.204 27.204 0 0 1-.046-1.246V5.39h.87v4.521zm1.785 0V5.391h.967v3.73h1.848v.791h-2.815zm8.255-2.267c0 .749-.188 1.324-.562 1.726-.374.402-.91.603-1.608.603-.698 0-1.235-.2-1.609-.603-.374-.402-.56-.98-.56-1.732s.187-1.327.562-1.724c.375-.397.913-.595 1.613-.595s1.236.2 1.607.6c.371.4.557.975.557 1.725zm-3.327 0c0 .506.097.886.29 1.142.194.255.482.383.867.383.77 0 1.156-.508 1.156-1.525 0-1.018-.383-1.527-1.15-1.527-.384 0-.674.128-.87.385-.195.256-.293.637-.293 1.142zm6.845-1.521c-.363 0-.645.135-.844.406-.2.272-.3.65-.3 1.134 0 1.008.382 1.512 1.144 1.512.32 0 .708-.08 1.163-.238v.804a3.252 3.252 0 0 1-1.253.232c-.663 0-1.17-.2-1.521-.598-.352-.4-.527-.972-.527-1.718 0-.47.086-.882.259-1.236a1.86 1.86 0 0 1 .743-.813c.323-.189.702-.283 1.136-.283.443 0 .888.106 1.335.318l-.312.78c-.17-.08-.342-.15-.515-.21a1.545 1.545 0 0 0-.508-.09zm6.437 3.788h-1.097L47.19 8.007l-.409.29v1.615h-.966V5.391h.966V7.46l.38-.532 1.235-1.537h1.073l-1.59 2 1.602 2.521zm6.299 0l-.33-1.076h-1.662l-.33 1.076h-1.042l1.609-4.54h1.181l1.615 4.54h-1.041zm-.561-1.88a316.5 316.5 0 0 1-.516-1.655 4.641 4.641 0 0 1-.083-.303 61.05 61.05 0 0 1-.589 1.958h1.188zM59 7.519h.318c.298 0 .52-.059.668-.175.147-.117.22-.286.22-.509 0-.225-.061-.39-.185-.498-.123-.107-.317-.16-.581-.16H59v1.342zm2.183-.718c0 .487-.154.859-.46 1.117-.307.257-.743.386-1.308.386H59v1.608h-.966V5.391h1.456c.553 0 .973.118 1.26.354.289.236.433.588.433 1.056zm2.465.718h.318c.297 0 .52-.059.667-.175.147-.117.221-.286.221-.509 0-.225-.062-.39-.185-.498-.124-.107-.318-.16-.582-.16h-.44v1.342zM65.83 6.8c0 .487-.153.859-.46 1.117-.306.257-.742.386-1.308.386h-.414v1.608h-.967V5.391h1.456c.553 0 .973.118 1.261.354.288.236.432.588.432 1.056z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockGrey);
export default __webpack_public_path__ + "static/media/UnlockGrey.1374402ccc1ab1110d4b4688d503eb9a.svg";
export { ForwardRef as ReactComponent };